import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { TranslateService } from '@ngx-translate/core';
import { ErrorMessagePipe } from './error-message/error-message.pipe';
import { InputDirective } from './input/input.directive';
import { NebulaAutofocusDirective } from './nebula-autofocus/nebula-autofocus.directive';
import { NebulaProgressIndicatorDirective } from './nebula-progress-indicator/nebula-progress-indicator.directive';
import { NebulaTrapKeyboardEventsDirective } from './nebula-trap-keyboard-events/nebula-trap-keyboard-events.directive';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatInputModule
  ],
  exports: [
    ReactiveFormsModule,
    MatInputModule,
    ErrorMessagePipe,
    NebulaAutofocusDirective,
    NebulaTrapKeyboardEventsDirective,
    InputDirective,
    NebulaProgressIndicatorDirective
  ],
  declarations: [
    ErrorMessagePipe,
    NebulaAutofocusDirective,
    NebulaTrapKeyboardEventsDirective,
    InputDirective,
    NebulaProgressIndicatorDirective
  ],
  providers: [
    TranslateService
  ]
})
export class NebulaFormsModule { }
